import { schema } from 'normalizr';

const DevicePricingSchema = new schema.Entity('devicePricing');
const FeaturePricingSchema = new schema.Entity('featurePricing');
const InvoiceSchema = new schema.Entity('invoices');
const BillingAccountNoteSchema = new schema.Entity('billingAccountNotes');
const BillingAccountAgreementSchema = new schema.Entity('billingAgreements');
const BillingAccountSchema = new schema.Entity('billingAccounts', {
  notes: [BillingAccountNoteSchema],
  agreements: [BillingAccountAgreementSchema],
});

export {
  DevicePricingSchema,
  FeaturePricingSchema,
  BillingAccountSchema,
  BillingAccountAgreementSchema,
  InvoiceSchema,
};
